module.exports = function (app) {
	'use strict';

	app.directive('eprQualifyingEvent', function () {
		return {
			template: require('directives/employee/eprQualifyingEvent.html'),
			restrict: 'A',
			replace: true,

			scope: {
				employee: '=eprQualifyingEvent',
				editMode: '=?'
			}
		};
	});
};
